<div fxLayout="row" class="background">

  <div fxFlex="75" fxFlexOffset="12%">

    <section id="header">
      <h1 class="h1Header">PEDIDOS RECHAZADOS</h1>
    </section>
    
    <div fxLayout="row" class="tablaCom">
      <div fxFlex=120 fxFlexOffset="-25%">
        <mat-card class="mat-elevation-z0">

          <mat-form-field appearance="outline">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ingresar número de pedido" #input>
          </mat-form-field>

          
          <mat-tab-group mat-align-tabs="start">
            <mat-tab class="tabLabel" label="RECHAZADOS">
          <mat-table [dataSource]="dataSource" class="tabla">
            <!-- Codigo Column -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef class="table-header"> ID</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content" 
                [ngClass]="order.dsPayment === 'Tarjeta' ? 'card' : ''">{{order.cdOrder}}</mat-cell>
            </ng-container>

            <!-- Store Column -->
            <ng-container matColumnDef="comercio">
              <mat-header-cell *matHeaderCellDef class="table-header">Comercio </mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content" 
                [ngClass]="order.dsPayment === 'Tarjeta' ? 'card': ''"> {{order.dsStoreName}}</mat-cell>
            </ng-container>

            <!-- User Column -->
            <ng-container matColumnDef="usuario">
              <mat-header-cell *matHeaderCellDef class="table-header">Usuario</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content" 
                [ngClass]="order.dsPayment === 'Tarjeta' ? 'card': ''"> {{order.dsUserName}}<br> {{order.dsPhone}}
              </mat-cell>
            </ng-container>

            <!-- Address Column -->
            <ng-container matColumnDef="direccion">
              <mat-header-cell *matHeaderCellDef class="table-header">Dirección</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content" 
                [ngClass]="order.dsPayment === 'Tarjeta' ? 'card': ''"> {{order.dsAddress}} </mat-cell>
            </ng-container>

            <!-- Items Column -->
            <ng-container matColumnDef="items">
              <mat-header-cell *matHeaderCellDef class="table-header"> Items</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">
                <button mat-button (click)="openOrder(order.cdOrder)">Ver</button>
              </mat-cell>
            </ng-container>

            <!-- total Column  -->
            <ng-container matColumnDef="total">
              <mat-header-cell *matHeaderCellDef class="table-header">Total</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content" 
                [ngClass]="order.dsPayment === 'Tarjeta' ? 'card': ''">{{order.qtTotal}}</mat-cell>
            </ng-container>

            <!-- Options Column -->

            <ng-container matColumnDef="opciones">
              <mat-header-cell *matHeaderCellDef class="table-header">Fecha Cancelación</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">
                <p class="rejected">Rechazado</p>
                <p [ngClass]="order.dsPayment === 'Tarjeta' ? 'card': ''">Pago:<br>{{order.dsPayment}}</p>
                <div class="detail">{{order.dtUpdatedAt | date:'HH:mm dd-MM-yyyy'}}</div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>
        </mat-tab>
        <mat-tab label="RECHAZADOS PAGADOS CON TARJETA">
          <app-rejected-with-card-shop-orders></app-rejected-with-card-shop-orders>
        </mat-tab>
      </mat-tab-group>
          <div *ngIf="dataSource.filteredData.length === 0" fxLayout="row" fxLayoutAlign="center center">
            <span class="cardHeader">
              No se encontraron pedidos con ese código</span>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

</div>
